import { useQuery } from '@tanstack/react-query';
import { IOperationResult } from '../../extViewmodels';
import { Website } from '../../extViewmodels/sdk/models/Website';
import { BASE_URL } from '../constants';

const BASE_QUERY_KEY = `/website/<id>`;

export function useWebsiteViewAppQuery({ id, token, enabled }: { id: string; token: string; enabled?: boolean }) {
	return useQuery({
		queryKey: [BASE_QUERY_KEY, id],
		queryFn: async () => {
			const response = await fetch(`${BASE_URL}/website/${id}`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `bearer ${token}`,
				},
			});
			const result: IOperationResult<Website> = await response.json();
			return result.value;
		},
		enabled,
	});
}
